import { useQueryState } from 'nuqs';

import { ManualTabType } from '../../../type/manual-tab-type.enum';

type ManualTabTypeValue = ManualTabType | null;

/**
 * Manual 페이지 URL 쿼리 파라미터 상수
 */
export const MANUAL_URL_PARAMS = {
  TAB_TYPE: 'tabType',
} as const;

/**
 * 메인 페이지 탭 상태를 URL 쿼리 파라미터로 관리
 */
const useManualTabQuery = () => {
  const [tabType, setTabType] = useQueryState<ManualTabTypeValue>(
    MANUAL_URL_PARAMS.TAB_TYPE,
    {
      defaultValue: null,
      parse: (value: string) => {
        if (Object.values(ManualTabType).includes(value as ManualTabType)) {
          return value as ManualTabType;
        }
        return null;
      },
      serialize: (value: ManualTabTypeValue) => value ?? '',
    },
  );

  // tabType을 숫자 인덱스로 변환
  const currentTab: number = (() => {
    if (tabType === ManualTabType.REVIEW) return 1;
    if (tabType === ManualTabType.FAQ) return 2;
    return 0; // 기본값: 이용 안내
  })();

  // 숫자 인덱스를 tabType으로 변환하여 설정
  const setCurrentTab = (index: number) => {
    if (index === 1) {
      setTabType(ManualTabType.REVIEW);
    } else if (index === 2) {
      setTabType(ManualTabType.FAQ);
    } else {
      setTabType(() => null);
    }
  };

  return {
    currentTab,
    tabType,
    setCurrentTab,
    setTabType,
  };
};

export default useManualTabQuery;
